import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Typography
} from '@mui/material'
import { observer } from 'mobx-react'

import { useStore } from 'stores'

function stringSetOrUndefined(value: string | undefined): string | undefined {
  if (value?.trim() === '') return undefined
  return value
}

const StatusPage = observer(() => {
  const { app: appStore } = useStore()

  const data: Array<{ label: string; value: string }> = [
    {
      label: 'Backend Version',
      value: stringSetOrUndefined(appStore.remoteVersion) ?? 'Unbekannt'
    },
    {
      label: 'Frontend Version',
      value: stringSetOrUndefined(process.env.REACT_APP_GIT_REF) ?? 'Unbekannt'
    },
    {
      label: 'Backend URL',
      value:
        stringSetOrUndefined(process.env.REACT_APP_API_URL) ??
        window.location.hostname
    }
  ]

  return (
    <Container>
      <Box sx={{ m: 2 }}>
        <Grid container spacing={2}>
          {data.map((item) => {
            return (
              <Grid item key={item.label}>
                <Card>
                  <CardContent>
                    <Typography
                      sx={{ fontSize: 14 }}
                      color="text.secondary"
                      gutterBottom
                    >
                      {item.label}
                    </Typography>
                    <Typography variant="h5" component="div">
                      {item.value}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            )
          })}
        </Grid>
      </Box>
    </Container>
  )
})

export default StatusPage
